<template>
  <div id="systemNotice">
    <p class="title-txt">公告管理</p>
    <!-- 列表 -->
    <div class="list-box">
      <div class="bg">
        <div class="search-box">
          <el-button type="primary" @click="putOut">发布公告</el-button>
        </div>
        <div class="company-list clearfix">
          <ul class="list-title" style="position: relative; top: 25px; width: 97.6%;">
            <li class="w-18">时间</li>
            <li class="w-18">通知方式</li>
            <li class="w-12">发布者</li>
            <li class="w-12">发布范围</li>
            <li class="w-50">内容</li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
              <li :title="changeTime(item.createdTime)" class="w-18">{{changeTime(item.createdTime)}}</li>
              <li class="w-18" :title="getWay(item.way)">{{getWay(item.way)}}</li>
              <li :title="item.userName" class="w-12">{{item.userName}}</li>
              <li :title="item.targetName" class="w-12">
                {{item.targetName}}
              </li>
              <li :title="item.context" class="w-50">{{item.context}}</li>
            </ul>
          </div>
        </div>
        <!-- 没有列表数据 -->
        <div class="nullDataBox" v-show="dataList.length==0">
          <img :src="nullData" class="nullData">
          <span>什么东西都没有找到...</span>
        </div>
      </div>
      <!-- 分页 -->
      <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
    </div>
    <div class="popup">
      <div class="popup-box" v-show="show">
        <div class="popup-title">
          发布公告</i><i class="el-icon-circle-close close" @click="close('show')" id="closeAdd1"></i>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="通知方式：" autocomplete="off">
            <el-checkbox-group v-model="ruleForm.way" :min="1" style="width: 100%;">
              <el-checkbox :label="1">站内</el-checkbox>
              <el-checkbox :label="2">公众号</el-checkbox>
              <el-checkbox :label="3">短信</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="通知对象：" autocomplete="off" prop="target" style="margin-bottom: 12px;">
            <i class="f-l edit-noticeObj" @click="showRole"><img :src="this.cssType==0?edit0:edit1" class="notes"
                style="width: 20px;">编辑</i>
            <div class="noticeObj-box" :class="{'error': roleError}">
              <p class="role-list" v-for="role in oldRoleList">
                <!-- <span v-if="role.type==1">{{role.name}}(通用)</span> -->
                <span>{{role.name}}<span v-show="role.groupName">/{{role.groupName}}</span></span>
              </p>
            </div>
          </el-form-item>
          <el-form-item label="内容：" autocomplete="off" prop="context">
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="ruleForm.context" resize="none"
              class="height-100">
            </el-input>
          </el-form-item>
        </el-form>
        <p class="btn-box">
          <el-button type="primary" @click="addNotice">确定</el-button>
          <el-button @click="close('show')">取消</el-button>
        </p>
      </div>

      <div class="popup-role" v-show="roleShow">
        <div class="popup-title">
          通知对象
          <div class="content-box">
            <div class="roleTree tree p-l-0">
              <p class="roleTree-top">可选</p>
              <div class="tree-box">
                <el-tree :indent='0' ref="noticeTree" :data="noticeTree" node-key="code" :expand-on-click-node="false"
                  :show-checkbox="true" :check-strictly="true" :props="defaultProps" :default-expand-all="true"
                  @check-change="handleCheckChange">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? jczu :data.type == 3 ? qyzu:user"
                        class="tree-icon"></i>
                    <span>{{ node.label }} <span v-if='node.level==1&&data.roleName'>({{data.roleName}})</span></span>
                  </span>
                  </span>
                </el-tree>
              </div>
            </div>
            <div class="role-selected">
              <p class="roleTree-top">已选</p>
              <div class="addrole-list">
                <p v-for="addRole,a in addRoleList" @mouseover="delCode = addRole.id" :tabindex="addRole.id"
                  class="c-pointer del-option">
                  <!--:class="[{ 'currency': addRole.type == 1 },'c-pointer','del-option']" -->
                  <i><img :src="addRole.type == 1 ? branch : addRole.type == 2 ? jczu :addRole.type == 3 ? qyzu:user"
                      class="role-icon"></i>
                  {{addRole.name}}<span v-show="addRole.groupName">/{{addRole.groupName}}</span>
                  <i v-show="addRole.id == delCode"><img :src="delIcon" title='删除' class="add-icon del-icon"
                      @click="delRole(addRole,a)" :id="`delRoleList${a}`"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <p class="btn-box">
          <el-button type="primary" @click="editRole" id="yesEditRole">确定</el-button>
          <el-button @click="closeRole" id="noEditRole">取消</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import Pagination from "@/components/PublicAssembly/pagination"
  export default {
    data() {
      var verifyTarget = (rule, value, callback) => {
        console.log(this.ruleForm.target)
        if (this.ruleForm.target.length == 0) {
          this.roleError = true
          callback(new Error('请选择通知对象'))
        } else {
          this.roleError = false
          callback()
        }
      };
      return {
        nullData: require('@/assets/image/index/nullData.png'),
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        dataList: [],
        roleError: false,
        edit0: require('@/assets/image/organize/edit.png'),
        edit1: require('@/assets/image/organize/edit4.png'),
        branch: require("@/assets/image/company/ptzu.png"),
        user: require('@/assets/image/company/user.png'),
        jczu: require('@/assets/image/company/jczu.png'),
        qyzu: require('@/assets/image/company/qyzu.png'),
        delIcon: require('@/assets/image/organize/delete.png'),
        show: false,
        ruleForm: {
          way: [1],
          target: [],
          targetName: [],
          context: ''
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        rules: {
          context: {
            required: true,
            trigger: 'blur',
            message: '请输入内容',
          },
          target: {
            validator: verifyTarget,
            required: true,
            trigger: 'blur'
          },
        },
        allUserList: [], //所有用户
        // allRoleList:[],     //所有角色
        addRoleList: [], //已添加的角色列表
        oldRoleList: [], //已添加的旧角色列表
        noset: false,
        TreeData: [],
        noticeTree: [],
        delCode: '',
        roleShow: false,
      }
    },
    components: {
      Pagination,
    },
    computed:{
        getWay(){
          return (way)=>{
            if(way){
              let arr=way.split(',')
              let result =[]
              if(arr.includes("1")){
                result.push('站内')
              }
              if(arr.includes("2")){
                result.push('公众号')
              }
              if(arr.includes("3")){
                result.push('短信')
              }
              return result.toString()
            }else{
              return ''
            }
          }
        }
    },
    created() {
      this.$store.state.activeIndex = '/systemNotice'
      this.pageSize = this.$store.state.userConfig.rowsPerPage;
      this.getlist({
        pageNumber: this.pageNumber,
        length: Number(this.pageSize)
      });
      this.getTree()
    },
    methods: {
      // 发布
      addNotice() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let parm = {
              way: this.ruleForm.way.toString(),
              context: this.ruleForm.context,
              target: this.ruleForm.target.toString(),
              targetName: this.ruleForm.targetName.toString(),
              userName:this.$store.state.userData.displayName,
              userId:this.$store.state.userData.id
            }
            this.postNoJson('/SystemNotice/push', parm).then((res) => {
              if (res.success) {
                this.$message({
                  message: '发布成功',
                  type: 'success'
                });

                let parm2 = {
                  pageNumber: this.pageNumber,
                  length: this.pageSize
                }
                this.getlist(parm2)
                this.close('show')
              } else {
                this.$message({
                  message: `发布失败：${res.message}`,
                  type: 'warning'
                });
              }
            }).then(() => {

            })
          } else {
            return false;
          }
        });
      },
      //打开添加角色弹窗
      showRole(name) {
        this.noset = false //初始
        // this.changeForm()
        for (let obj of this.allUserList) {
          obj.name = obj.displayName
          obj.userType = obj.type
          obj.type = 4
          let tree = this.$refs.noticeTree.getNode(obj.groupCode)
          if (tree) { //将用户添加进通知角色树
            if (tree.data.children == null) {
              tree.data.children = []
            }
            this.$refs.noticeTree.getNode(obj.groupCode).data.children.unshift(obj)
          }
        }
        this.addRoleList = this.clone(this.oldRoleList)
        this.roleShow = true;
        this.$store.state.mask = true
        this.$forceUpdate(); //强制刷新下吧
      },
      putOut() {
        this.show = true
        this.$store.state.mask = true
      },
      // 获取列表
      getlist(parm) {
        this.get('/SystemNotice/query', parm).then((res) => {
          if (res.success) {
            this.dataList = res.result.data
            this.totalCount = res.result.totalCount
          } else {
            this.$message({
              message: `获取列表数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 修改分页size
      setSize(pageObj) {
        this.pageSize = pageObj.size;
        let parm = {
          pageNumber: this.pageNumber,
          length: this.pageSize
        }
        this.getlist(parm)
      },
      // 修改页数
      setNum(number) {
        this.pageNumber = number;
        let parm = {
          pageNumber: this.pageNumber,
          length: this.pageSize
        }
        this.getlist(parm)
      },
      getTree() {
        this.get('/Group/getOrganizationTree').then((res) => {
          if (res.success) {
            this.TreeData.push(res.result[0]);
            this.noticeTree = this.clone(this.TreeData)
            console.log(this.TreeData)
            this.getAllUser(this.TreeData[0].code)
          }
        })
      },
      // 获取所有用户
      getAllUser(code) {
        this.get('/User/getList', {
          code: code
        }).then((res) => {
          if (res.success) {
            this.allUserList = res.result;
            // 将用户添加进树中
            for (let obj of res.result) {
              obj.name = obj.displayName
              obj.userType = obj.type
              obj.type = 4
              let tree = this.$refs.noticeTree.getNode(obj.groupCode)
              if (tree) {
                if (tree.data.children == null) {
                  tree.data.children = []
                }
                tree.data.children.unshift(obj)
              }
            }
          }
        })
        this.$forceUpdate()
      },

      // 选择通知组或企业
      handleCheckChange(data, checked, indeterminate) {
        if (this.noset) { //删除按钮进行的操作不执行下面方法
          this.noset = false
          return
        }
        if (checked) {
          if (this.$refs.noticeTree.getNode(data.code).parent) {
            data.groupName = this.$refs.noticeTree.getNode(data.code).parent.data.name //获取通知对象上级组
          }
          // this.ruleForm.target.push(data.code);
          this.addRoleList.push(data)
        } else {
          for (let i in this.addRoleList) {
            if (data.code == this.addRoleList[i].code) {
              // this.ruleForm.target.splice(i,1)
              this.addRoleList.splice(i, 1)
            }
          }
        }
        this.$forceUpdate()
      },

      //删除角色
      delRole(role, a) {
        // console.log(role,a)
        this.addRoleList.splice(a, 1)
        this.noset = true //避免因触发tree 组件的事件而导致删除两次
        this.$refs.noticeTree.setChecked(role, false)
        this.$forceUpdate()
      },
      //修改角色
      editRole() {
        // let id="",name="";
        this.ruleForm.target = []
        this.ruleForm.targetName = []
        for (let role of this.addRoleList) {
          this.ruleForm.target.push(role.code)
          this.ruleForm.targetName.push(role.displayName || role.name)
        }
        this.roleShow = false;
        this.oldRoleList = this.clone(this.addRoleList) //保存此次角色列表
        this.$refs.ruleForm.validateField('target')
      },
      //关闭角色弹窗
      closeRole() {
        this.roleShow = false;
        this.noset = true
        this.$refs.noticeTree.setCheckedKeys([], false) //清除通知对象树上的已勾选的节点
        let arr = []
        for (let role of this.addRoleList) {
          role.selectType = false //重置选中状态
        }
        for (let i in this.oldRoleList) {
          arr.push(this.oldRoleList[i].code)
          if (i == this.oldRoleList.length - 1) {
            this.noset = true
            this.$refs.noticeTree.setCheckedKeys(arr, true) //设置已勾选
          }
        }

        this.addRoleList = this.clone(this.oldRoleList) //还原上次添加的角色列表
      },
      // 关闭弹窗
      close(name) {
        this[name] = false;
        this.$store.state.mask = false;
        this.ruleForm = this.$options.data().ruleForm
        this.addRoleList = []
        this.oldRoleList = []
        this.roleError = false
        this.$refs.noticeTree.setCheckedKeys([])
      },
    },
  }
</script>
<style scoped>
  .popup-box {
    padding-bottom: 100px !important;
  }

  .search-box {
    text-align: left;
    padding: 16px 16px 0
  }

  .btn-box {
    position: absolute;
    text-align: center;
    bottom: 36px;
    width: 100%;
    left: 0;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  .roleTree,
  .role-selecting {
    border-right: 1px solid #d2d2d2;
  }

  .roleTree .el-tree {
    height: 95%;
  }

  .role-icon {
    width: 16px;
    position: relative;
    padding-left: 19px;
    top: 3px;
  }

  .add-icon {
    width: 16px;
    position: absolute;
    right: 12px;
    top: 10px;
  }

  .del-icon {
    width: 12px;
  }

  .tree-box {
    width: 100%;
    height: 390px;
    overflow: auto;
  }

  .currency {
    color: #073178 !important;
  }


  .role-option,
  .del-option {
    position: relative;
  }

  .del-option:hover {
    outline: none;
    background-color: #f5f5f5;
  }

  .selecting-box,
  .addrole-list {
    overflow: auto;
    height: 390px;
  }

  .addrole-list {
    line-height: 28px;
    font-size: 14px;
    box-sizing: border-box;
  }

  .del-option {
    padding-right: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .del-option:focus {
    outline: none;
    background-color: #f5f5f5;
  }

  .addrole-list {
    line-height: 28px;
    font-size: 14px;
    box-sizing: border-box;
  }

  .del-option {
    padding-right: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .del-option:focus {
    outline: none;
    background-color: #f5f5f5;
  }

  .roleTree-top {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    background-color: #eee;
  }

  img.tree-icon {
    width: 16px !important;
    position: relative;
    top: 3px;
    left: -2px;
  }

  .tree-disable-input {
    color: #dadada;
    border: 1px solid #ececec;
    line-height: 32px;
    border-radius: 5px;
    margin-top: 38px;
    padding-left: 14px;
  }

  .content-box {
    height: 418px;
    border: 1px solid #d2d2d2;
    border-bottom: 0;
  }

  .content-box>div {
    float: left;
    height: 100%;
    width: 277.5px;
    line-height: 34px;
  }

  .popup-role {
    width: 614px !important;
    height: 582px !important;
    margin-left: -307px !important;
    z-index: 9999;
    background-color: #fff;
  }

  .edit-noticeObj {
    color: #5087e4;
    padding-left: 14px;
    cursor: pointer;
  }

  .edit-noticeObj img {
    left: -7px !important;
  }

  .noticeObj-box {
    width: 100%;
    height: 108px;
    border: 1px solid #dedede;
    overflow: auto;
    line-height: 24px;
    box-sizing: border-box;
    padding: 5px 15px;
    border-radius: 4px;
  }

  img.notes {
    position: relative;
    left: 5px;
    top: 3px;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popup>div {
    position: fixed;
    top: 12%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -407px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 30px;
    text-align: left;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  i img.zuo {
    width: 14px;
    position: relative;
    top: 1px;
    margin-right: 5px;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px;
  }

  .title-txt {
    text-align: left;
    font-size: 16px;
    padding-left: 16px;
  }

  .list-box {
    position: absolute;
    top: 40px;
    left: 16px;
    right: 0;
    bottom: 0;
  }

  .list-top {
    margin: 0px 16px 15px 16px;
    padding-top: 24px;
    height: 34px;
  }

  .search-btn {
    float: right;
  }

  .company-list {
    overflow: hidden;
    height: 91%;
  }

  .scroll {
    overflow: auto;
    width: 97.6%;
    height: calc(100% - 140px);
    max-height: calc(100% - 140px) !important;
    margin: 0 16px;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    margin-top: 24px;
  }

  /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
  .list-title,
  .list-details {
    display: flex;
    justify-content: space-around;
    line-height: 44px;
    font-size: 14px;
    color: #636363;
  }

  .list-title {
    background: #eeeeee;
  }

  .list-title li,
  .list-details li {
    width: 200px;
    margin: 0 20px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list-details {
    border-top: 1px solid #f2f2f2;
  }

  .operate span {
    margin: 0 4px;
    color: #5087e4;
  }
  .w-12{
    width: 12% !important;
  }
  .w-18 {
    width: 18% !important;
  }

  .w-50 {
    width: 50% !important;
  }

  .list-details:last-child {
    border-bottom: 1px solid #f2f2f2;
  }

  .bg {
    width: 100%;
    height: calc(100% - 60px);
  }

  .error {
    border-color: #f56c6c;
  }
</style>
<style>
  #systemNotice .el-form-item__label {
    /* width: 100%; */
    text-align: left;
  }

  #systemNotice .el-form-item {
    margin-bottom: 0;
  }

  .height-100 textarea {
    height: 120px !important;
  }
  .tree .is-current>.el-tree-node__content{
      background-color: #dfdfdf !important;
  }
  /* 修改ele-ui 默认样式 */
  .tree .el-tree-node__content .custom-tree-node{
      font-size: 14px !important;
      margin-left: 10px;
      position: relative;
      justify-content:stretch !important;
  }
  .tree .el-tree-node__children .custom-tree-node{
      font-size: 14px !important;
      padding-right: 10px;
  }
  .el-tree-node>.el-tree-node__children {
      overflow: unset !important;
  }
  .tree .el-tree > .el-tree-node:after {
      border-top: none;
  }
  .tree .el-tree-node {
      position: relative;
      padding-left: 16px;
  }
  .tree .el-tree-node__content {
      background: #fff;
  }
  /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
  .tree .el-tree-node__expand-icon.is-leaf{
      display: none;
  }
  .tree .el-tree-node__children {
      padding-left: 16px;
  }
  .tree .el-tree-node :last-child:before {
      height: 18px;
  }
  .tree .el-tree > .el-tree-node:before {
      border-left: none;
  }
  .tree .el-tree > .el-tree-node:after {
      border-top: none;
  }
  .tree .el-tree-node:before {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
  }
  .tree .el-tree-node:after {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
  }
  .tree .el-tree-node:before {
      border-left: 1px dashed #dedede;
      bottom: 0px;
      height: 100%;
      top: -7px;
      width: 1px;
  }
  .tree .el-tree-node:after {
      border-top: 1px dashed #dedede;
      height: 20px;
      top: 12px;
      width: 24px;
  }
  .el-input__inner{
      color: #252525;
  }
  .dashed .el-tree-node:before {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
  }
  .dashed .el-tree-node:after {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
  }
  .dashed .el-tree-node:before {
      border-left: 1px dashed #dedede;
      bottom: 0px;
      height: 100%;
      top: -7px;
      width: 1px;
  }
  .dashed .el-tree-node:after {
      border-top: 1px dashed #dedede;
      height: 20px;
      top: 12px;
      width: 24px;
  }
  .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/SetUp/SystemNotice.vue